import {
  TOPIC_CONTENT_SOURCES,
  type TopicContentSource,
} from "./topic-content-sources";

export const HOME_LOAN_REFINANCE_SOURCES_A = [
  {
    sourceId: "home-loan-refinance-source-overview",
    topicId: "home-loan-refinance",
    title: "Home loans",
    publisher: "Moneysmart",
    url: "https://moneysmart.gov.au/home-loans",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Australian Government Moneysmart 공식 본문에서 home-loan 비교, refinancing, repayment difficulty와 independent financial guidance 경로를 확인",
    reviewStatus: "live_verified",
    claimScope: "호주 home loan 선택·관리·refinancing의 일반 소비자 기준",
    followUp: "행동 직전 lender product disclosure, current rate·fees와 개인 credit assessment를 확인",
  },
  {
    sourceId: "home-loan-refinance-source-choosing",
    topicId: "home-loan-refinance",
    title: "Choosing a home loan",
    publisher: "Moneysmart",
    url: "https://moneysmart.gov.au/home-loans/choosing-a-home-loan",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Moneysmart 공식 본문에서 fixed·variable·split loan, comparison rate, repayment flexibility, offset·redraw와 break-fee trade-offs를 확인",
    reviewStatus: "live_verified",
    claimScope: "home-loan type·features·fees와 comparison-rate 비교",
    followUp: "같은 loan amount·term·repayment type으로 current offer와 new offer를 재계산",
  },
  {
    sourceId: "home-loan-refinance-source-switching",
    topicId: "home-loan-refinance",
    title: "Switching home loans",
    publisher: "Moneysmart",
    url: "https://moneysmart.gov.au/home-loans/switching-home-loans",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Moneysmart 공식 본문에서 current lender negotiation, break·discharge·application·switching costs, LMI risk, new term과 overall savings를 확인",
    reviewStatus: "live_verified",
    claimScope: "호주 mortgage refinancing의 switching costs·equity·term·break-even 검토",
    followUp: "current payout quote, property valuation, LVR, LMI, cashback와 settlement costs를 written quote로 확인",
  },
  {
    sourceId: "home-loan-refinance-source-faster",
    topicId: "home-loan-refinance",
    title: "Pay off your mortgage faster",
    publisher: "Moneysmart",
    url: "https://moneysmart.gov.au/home-loans/pay-off-your-mortgage-faster",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Moneysmart 공식 본문에서 lower rate 협상, repayments 유지·증가, extra payments, offset과 switching cost 확인을 검증",
    reviewStatus: "live_verified",
    claimScope: "refinancing 전후 mortgage interest·repayment term 관리",
    followUp: "extra repayment·redraw limits와 fixed-loan restrictions를 lender terms에서 확인",
  },
] as const satisfies readonly TopicContentSource[];

const mutableSources = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of HOME_LOAN_REFINANCE_SOURCES_A) {
  if (!mutableSources.some((existing) => existing.sourceId === source.sourceId)) {
    mutableSources.push(source);
  }
}
